// extracted by mini-css-extract-plugin
module.exports = {"bottomContainer":"styles_bottomContainer__-6RCJ","list":"styles_list__3hnya"};